import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
    resources:{
        en: {
            translation: {
                title: 'CineFX',
                ciao: "Hi",
                account: "Account",
                manageabbonamento: "Manage your profile and subscription.",
                yourprofile: "Your profile",
                yoursubscription: "Your subscription",
                youdonthavesubscription: "You don't have a subscription yet.",
                subscribelabel: "Subscribe to access all features without limits.",
                subscribe: "Subscribe",
                name: "Name",
                surname: "Surname",
                email: "Email",
                uid: "UID",
                status: "Status",
                active: "Active",
                startsubscription: "Subscription start",
                nextrenew: "Next renewal",
                frequency: "Frequency",
                annualprice: "Annual price",
                invoices: "INVOICES",
                invoicenumber: "Invoice number",
                date: "Date",
                price: "Amount",
                downloadinvoice: "Download invoice",
                indata: "On",
                hairichiestoannullamento: "you have requested the cancellation of your subscription.",
                subscriptionwillbeinterruptedon: "The subscription will be interrupted on",
                restoresubscriptionquestion: "Restore the subscription?",
                restoresubscription: "Restore subscription",
                deletesubscriptionquestion: "Cancel the subscription?",
                deletesubscription: "Cancel subscription",
                cancelled: "Cancelled",
                ended: "Ended",
                notavailable: "N/A",
                emailplaceholder: "name@email.com",
                password: "Password",
                login: "Login",
                passwordforgot: "Forgot password",
                back: "Back",
                resetpsw: "Reset password",
                emailsent: "We have sent you an email with instructions to reset your password",
                backtologin: "Back to login",
                alreadyhavesub: "You already have a subscription.",
                backtoaccount: "Back to your account",
                cart: "Cart",
                product: "Product",
                type: "Type",
                subscription: "Subscription",
                annual: "Annual",
                pricefirstyear: "Price for the first year",
                emailcinefxaccount: "CineFX account email",
                cinefx: "CineFX",
                topaytoday: "Total to pay today",
                subrenewsat: "The subscription renews automatically at",
                youcancancelanytime: "You can cancel anytime. See",
                termsandconditions: "Terms and Conditions",
                paymentmethod: "Payment method",
                declareto: "By clicking on Pay, you declare that you have read and agree to the",
                andthe: "and the ",
                privacypolicy: "Privacy Policy",
                pay: "PAY",
                billingdetails: "Billing details",
                vat: "Tax code",
                country: "Country",
                city: "City",
                address: "Address",
                streetnumber: "Street number",
                next: "Next",
                paymentcompleted: "Payment completed",
                paymentcompletedlabel: "Your payment was successful.",
            }
        },
        it: {
            translation: {
                title: 'CineFX',
                ciao: "Ciao",
                account: "Account",
                manageabbonamento: "Gestisci il tuo profilo e il tuo abbonamento.",
                yourprofile: "Il tuo profilo",
                yoursubscription: "Il tuo abbonamento",
                youdonthavesubscription: "Non hai ancora un abbonamento.",
                subscribelabel: "Per usufruire di tutte le funzionalità senza limiti, abbonati.",
                subscribe: "Abbonati",
                name: "Nome",
                surname: "Cognome",
                email: "Email",
                uid: "UID",
                status: "Status",
                active: "Attivo",
                startsubscription: "Inizio abbonamento",
                nextrenew: "Prossimo rinnovo",
                frequency: "Frequenza",
                annualprice: "Prezzo annuale",
                invoices: "FATTURE",
                invoicenumber: "Numero fattura",
                date: "Data",
                price: "Importo",
                downloadinvoice: "Scarica la fattura",
                indata: "In data",
                hairichiestoannullamento: "hai richiesto la cancellazione dell'abbonamento.",
                subscriptionwillbeinterruptedon: "L'abbonamento verrà interrotto il",
                restoresubscriptionquestion: "Ripristinare l'abbonamento?",
                restoresubscription: "Ripristina abbonamento",
                deletesubscriptionquestion: "Annullare l'abbonamento?",
                deletesubscription: "Annulla abbonamento",
                cancelled: "Cancellato",
                ended: "Terminato",
                notavailable: "N/A",
                emailplaceholder: "nome@email.com",
                password: "Password",
                login: "Accedi",
                passwordforgot: "Ho dimenticato la password",
                back: "Indietro",
                resetpsw: "Reimposta password",
                emailsent: "Ti abbiamo inviato una mail con le istruzioni per il reset della password",
                backtologin: "Torna al login",
                alreadyhavesub: "Hai già un abbonamento.",
                backtoaccount: "Torna al tuo account",
                cart: "Carrello",
                product: "Prodotto",
                type: "Tipo",
                subscription: "Abbonamento",
                annual: "Annuale",
                pricefirstyear: "Prezzo per il primo anno",
                emailcinefxaccount: "Email account CineFX",
                cinefx: "CineFX",
                topaytoday: "Totale da pagare oggi",
                subrenewsat: "L'abbonamento di rinnova in automatico a",
                youcancancelanytime: "Puoi disdire quando vuoi. Si applicano",
                termsandconditions: "Termini e Condizioni",
                paymentmethod: "Metodo di pagamento",
                declareto: "Cliccando su Paga, dichiari di aver letto e accettato i",
                andthe: "e l'",
                privacypolicy: "Informativa sulla Privacy",
                pay: "PAGA",
                billingdetails: "Dettagli di fatturazione",
                vat: "Codice fiscale",
                country: "Paese",
                city: "Città",
                address: "Indirizzo",
                streetnumber: "Civico",
                next: "Avanti",
                paymentcompleted: "Pagamento completato",
                paymentcompletedlabel: "Il tuo pagamento è andato a buon fine.",
            }
        },
    }
});

export default i18n;